import { render, staticRenderFns } from "./InventoryForm.vue?vue&type=template&id=3895a39c"
import script from "./InventoryForm.vue?vue&type=script&lang=js"
export * from "./InventoryForm.vue?vue&type=script&lang=js"
import style0 from "./InventoryForm.vue?vue&type=style&index=0&id=3895a39c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports